import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons';
import * as React from 'react';
import { FontAwesomeIcon } from './helpers/FontAwesomeIcon';

export const DeficiencyIcon = (props: { color?: string }) => {
  return (
    <FontAwesomeIcon icon={faExclamationCircle} color={props.color || 'black'} />
  )
}
